<template>
  <div class="overflow-hidden p-about">
    <div class="c-pageHerderWrap">
      <div class="c-pageHerder">
        <h1 class="has-border"><span>About us</span>ゆずりはについて</h1>
      </div>
    </div>
    <section class="p-about c-container">
      <h2 class="c-title--01">
        <transition
            appear
            @enter="staggerText"
        >
          <span v-html="spanWrapText(`ゆずりはとは`)"></span>
        </transition>
        <transition
            appear
            @enter="fadeInUp"
        >
          <span class="en">What is yuzuriha?</span>
        </transition>
      </h2>
      <transition
          appear
          @enter="fadeInUp"
      >
      <p>ゆずりはでは、児童養護施設や里親家庭などで生活していた人、虐待や支配などの理由から親や家族を頼ることができない人から様々な相談を受けています。「どこにも帰る場所がない」「借金がある」「家族やパートナーから暴力を受けている」「保証人がいない」「妊娠をした」など、一人で対応していくにはとても難しい困難や問題を、一緒に考え、整理したり、手続きするサポートしています。その他、気軽に集えるサロン、一緒に働くゆずりは工房、高卒認定の学習会、虐待に至ってしまった親へのプログラム（MY
        TREEプログラム）、などを行っています。</p>
      </transition>
    </section>
    <section class="p-important c-container">
      <h2 class="c-title--01">
        <transition
            appear
            @enter="staggerText"
        >
          <span v-html="spanWrapText(`大切にしていること`)"></span>
        </transition>
        <transition
            appear
            @enter="fadeInUp"
        >
          <span class="en">What is important</span>
        </transition>
      </h2>
      <transition
          appear
          @enter="fadeInUp"
      >
      <p>ゆずりはにたどり着いてくれた人たちが、親や家族から支配や虐待され、苦しさ・緊張・不安を抱え続けながらも、なんとか生きてきた道のりに思いを馳せること。見ず知らずのわたしたちに、勇気をもって相談してくれたことへのありがとうの気持ち。「支援する・される」の関係ではなく、互いを尊重しあえる対等な関係を育んでいくこと。そんなことを大切にしながら、出会えた人たちと安心で楽しい時間を重ねていきたいです。</p>
      </transition>
    </section>
    <section class="p-philosophy md:flex px-1/14 md:px-0">
      <div class="md:w-1/2">
        <transition
            appear
            @enter="inViewImage"
        >
          <picture class="inViewImage">
            <img class="w-full aspect-square object-cover" src="../assets/about/image02.jpg" alt="">
          </picture>
        </transition>
      </div>
      <div class="md:w-1/2 md:pl-16 mt-8 md:mt-0">
        <h2 class="c-title--01 text-[1.6875rem] tracking-[0.25em]">
          <transition
              appear
              @enter="staggerText"
          >
            <span v-html="spanWrapText(`出会えた人たちと 「安心」と「楽しい」をいっしょに`)"></span>
          </transition>
          <transition
              appear
              @enter="fadeInUp"
          >
            <span class="en text-sm mt-6">"Relieved" and "fun" together</span>
          </transition>
        </h2>
        <transition
            appear
            @enter="fadeInUpStagger"
        >
        <ul class="mt-8 philosophy__links">
          <li><a href="/philosophy">・ゆずりはのはじまり</a></li>
          <li><a href="/philosophy#action">・ゆずりはの活動</a></li>
          <li><a href="/philosophy#background">・困難な状況に至る背景</a></li>
          <li><a href="/philosophy#visit">・ゆずりはにたどりついてくれたひとたち</a></li>
          <li><a href="/philosophy#support">・社会的養育を経験していない子どもへの支援</a></li>
          <li><a href="/philosophy#independent">・「自立」をもう一度考える</a></li>
          <li><a href="/philosophy#thanks">・生きてきてくれてありがとう</a></li>
        </ul>
        </transition>
      </div>
    </section>

    <section class="p-member c-container">
      <h2 class="c-title--01">
      <transition
          appear
          @enter="staggerText"
      >
        <span v-html="spanWrapText(`メンバー紹介`)"></span>
      </transition>
      <transition
          appear
          @enter="fadeInUp"
      >
        <span class="en">Members Introduction</span>
      </transition>
      </h2>
      <transition
          appear
          @enter="fadeInUpStagger"
      >
      <ul class="p-member__list">
        <li>
          <img src="../assets/about/member01.png" alt="">
          <h3>あみ</h3>
          <p>大雑把で口が悪いが正直者。街の中に川がある景色が好き。海外ドラマ、散歩、風呂、酒で幸せ。</p>
        </li>
        <li>
          <img src="../assets/about/member02.png" alt="">
          <h3>桃子</h3>
          <p>派手髪のライターで、人の話を聴くのが好き。アート、漫画、哲学、まちづくりらへんに生息。</p>
        </li>
        <li>
          <img src="../assets/about/member03.png" alt="">
          <h3>詠子</h3>
          <p>根はマジメだけど、基本的には『まぁ、何とかなる』と楽天的に生きてる。Yogiboでごろ寝するのが大好き。</p>
        </li>
        <li>
          <img src="../assets/about/member04.png" alt="">
          <h3>ベッキー</h3>
          <p>元バスケ部(はるか昔)。ワインと日本酒があると機嫌良い。慎重なくせに適当な肝っ玉かあちゃん風。</p>
        </li>
        <li>
          <img src="../assets/about/member05.png" alt="">
          <h3>ゆうや</h3>
          <p>北海道出身。分からないことはすぐに携帯で調べてしまう。好きな食べ物は3日考えた結果、ハンバーグとなった。</p>
        </li>
        <li>
          <img src="../assets/about/member06.png" alt="">
          <h3>こまち</h3>
          <p>落語が好き。アボカドやニンジンの葉っぱを育てて観葉植物にしている。地味に長生きを目指しています^ ^</p>
        </li>
      </ul>
      </transition>
    </section>

    <section class="p-overview c-container">
      <div class="p-overview__body">
        <h2 class="c-title--01">
          <transition
              appear
              @enter="staggerText"
          >
            <span v-html="spanWrapText(`団体概要`)"></span>
          </transition>
          <transition
              appear
              @enter="fadeInUp"
          >
            <span class="en">Overview</span>
          </transition>
        </h2>
        <transition
            appear
            @enter="inViewImage"
        >
          <picture class="inViewImage mt-10">
            <img class="w-full object-cover h-64 md:h-96" src="../assets/about/image03.jpg" alt="">
          </picture>
        </transition>
        <transition
            appear
            @enter="fadeInUpStagger"
        >
        <dl class="c-table text-lg mt-4 md:mt-6">
          <div>
            <dt>運営主体者</dt>
            <dd>社会福祉法人「子供の家」理事長 江川修巳</dd>
          </div>
          <div>
            <dt>所在地</dt>
            <dd>〒185-0011 東京都国分寺市本多1-13-13<br/>TEL 042-315-6738</dd>
          </div>
          <div>
            <dt>責任者</dt>
            <dd>高橋亜美</dd>
          </div>
          <div>
            <dt>職員</dt>
            <dd>5名</dd>
          </div>
          <div>
            <dt>根拠法令等</dt>
            <dd>児童福祉法第41条</dd>
          </div>
          <div>
            <dt>開設年月日</dt>
            <dd>2011年4月1日</dd>
          </div>
          <div>
            <dt>事業内容</dt>
            <dd>東京都の地域生活支援事業「ふらっとホーム」を委託 （2013年4月1日より）<br/>社会福祉法人子供の家</dd>
          </div>
          <div>
            <dt>事業所</dt>
            <dd>社会福祉法人子供の家<br/>児童養護施設子供の家<br/>自立援助ホームあすなろ荘</dd>
          </div>
        </dl>
        </transition>
      </div>
    </section>

    <div class="bg-lightgray">
      <section class="p-report c-container">
        <h2 class="c-title--01">
          <transition
              appear
              @enter="staggerText"
          >
            <span v-html="spanWrapText(`事業報告･決算報告`)"></span>
          </transition>
          <transition
              appear
              @enter="fadeInUp"
          >
            <span class="en">Report</span>
          </transition>
        </h2>
        <transition
            appear
            @enter="fadeInUp"
        >
          <ReportList/>
        </transition>
      </section>
      <section class="p-media c-container">
        <h2 class="c-title--01">
          <transition
              appear
              @enter="staggerText"
          >
            <span v-html="spanWrapText(`メディア掲載･実績`)"></span>
          </transition>
          <transition
              appear
              @enter="fadeInUp"
          >
            <span class="en">Media ＆ Achievements</span>
          </transition>
        </h2>
        <transition
            appear
            @enter="fadeInUp"
        >
          <Accordion/>
        </transition>
        <div class="text-center">
          <a class="c-btn c-btn--02" href="/donation">
            Donation ›
            <span>寄付･参加</span>
          </a>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import Accordion from "../components/Accordion"
import ReportList from "../components/ReportList"

export default {
  components: {Accordion, ReportList},
}
</script>
